/** A Learning Lab global social profiles (matches main site footer). */
export const SOCIAL_LINKS = [
  {
    id: "facebook",
    label: "Facebook",
    href: "https://www.facebook.com/people/Learninglabglobal/61560928093112/",
  },
  {
    id: "youtube",
    label: "YouTube",
    href: "https://www.youtube.com/@ALearningLab/featured",
  },
  {
    id: "instagram",
    label: "Instagram",
    href: "https://www.instagram.com/alearninglabglobal/",
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/learninglabglobal/posts/",
  },
];
